import script from "./icon-apple.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-apple.vue?vue&type=script&lang=ts&setup=true"

import "./icon-apple.vue?vue&type=style&index=0&id=431bcfab&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-431bcfab"]])

export default __exports__